import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';

import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';
import { MDash } from 'ui-components/components/mdash';
import { Text, TextType } from 'ui-components/components/text';

import messages from '../messages';
import style from './style.module.less';

const name = (
  <Tooltip position='bottom'>
    <TooltipContent>
      <div className={style['tooltip-text']}>
        <Text textType={TextType.Paragraph} value={<FormattedMessage {...messages.inboundTooltipMessage} />} />
      </div>
    </TooltipContent>
    <div className={style.header}>
      <FormattedMessage {...messages.inboundColumnHeader} />
      <FontAwesomeIcon className={style.icon} icon={faInfoCircle} />
    </div>
  </Tooltip>
);

type InboundColumnProps = {
  inboundQuantity: number | null;
};

const InboundColumn = ({ inboundQuantity }: InboundColumnProps) => {
  if (inboundQuantity == null) {
    return <MDash />;
  }
  return <div className={style['right-align-column']}>{inboundQuantity}</div>;
};

export const inbound = {
  getMessageDescriptor: () => messages.inboundColumnHeader,
  name,
  render: InboundColumn,
};
